import logoUrl from '../assets/logo.svg';

// Default size is driven by CSS (.logo-img) so it can shrink on mobile.
// Pass `height` to override (e.g. footer keeps a fixed wordmark size).
export function Logo({ height }: { height?: number } = {}) {
  if (height != null) {
    return (
      <span className="logo" aria-label="Omega Trade and Finance">
        <img src={logoUrl} alt="" height={height} style={{ display: 'block', height, width: 'auto' }} />
      </span>
    );
  }
  return (
    <span className="logo" aria-label="Omega Trade and Finance">
      <img src={logoUrl} alt="" className="logo-img" />
    </span>
  );
}
